import { EntityId, EntityIdParams } from '@Models';

export class ReasonTypeView extends EntityId<number> {
  constructor(params: ReasonTypeViewParams) {
    super(params);
  }
}

export type ReasonTypeViewParams = EntityIdParams<number> & {};
